import React from 'react';
export function AboutAmee() {
  return <div className="mt-24 pt-12 border-t border-gray-200 flex flex-col md:flex-row items-center md:items-start text-center md:text-left" data-id="element-74">
      <div className="w-20 h-20 rounded-full bg-gray-200 overflow-hidden mb-6 md:mb-0 md:mr-8 flex-shrink-0 shadow-sm" data-id="element-75">
        <img src="https://cdn.magicpatterns.com/uploads/tiubNnjtMhUBpQvypWTGuU/Ontwerp_zonder_titel_(13).jpg" alt="Amee de Bruijn" className="w-full h-full object-cover" data-id="element-76" />
      </div>
      <div data-id="element-77">
        <h4 className="font-bold text-gray-900 text-xl mb-1" data-id="element-78">Amee de Bruijn</h4>
        <p className="text-sm text-gray-500 mb-4 font-medium uppercase tracking-wide" data-id="element-79">
          Gediplomeerd hondengedragsconsulent & oprichter Stressless Dogs
        </p>
        <p className="text-gray-600 italic text-lg leading-relaxed" data-id="element-80">
          "Mijn missie is om honden en hun baasjes weer écht met elkaar te
          verbinden, zonder dwang of strijd."
        </p>
      </div>
    </div>;
}